var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCcElo = function SvgCcElo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 38 26"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 25,
    x: 0.5,
    y: 0.5,
    stroke: "#D9D9D9",
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFAF6",
    d: "M34.429 1H3.57A2.571 2.571 0 0 0 1 3.571V22.43A2.571 2.571 0 0 0 3.571 25H34.43A2.571 2.571 0 0 0 37 22.429V3.57A2.571 2.571 0 0 0 34.429 1Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ccELO_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.744 12.222h2.105c.378-2.029 2.12-3.66 4.342-3.66 2.526 0 4.298 1.823 4.298 4.572 0 .294-.03.53-.058.735H8.636c.319 1.25 1.336 1.984 2.555 1.984 1.044 0 1.83-.411 2.454-1.132l1.25 1.161c-.83.956-2.064 1.618-3.704 1.618-2.223 0-3.964-1.602-4.34-3.631H4.743v-1.647Zm8.944 0a2.477 2.477 0 0 0-.654-1.324c-.435-.44-1.074-.72-1.843-.72-.77 0-1.395.264-1.859.734-.32.323-.58.764-.712 1.308h5.068v.002Zm3.064-3.601h1.83v7.056h3.31v1.764H18.61c-1.204 0-1.858-.662-1.858-1.882V8.621Zm5.488 4.41a4.473 4.473 0 0 1 4.487-4.47 4.466 4.466 0 0 1 4.414 3.661h2.104v1.647h-2.104a4.478 4.478 0 0 1-4.414 3.63 4.456 4.456 0 0 1-4.488-4.468Zm4.487 2.734c1.524 0 2.657-1.177 2.657-2.72 0-1.53-1.16-2.75-2.657-2.75-1.524 0-2.658 1.177-2.658 2.734 0 1.516 1.163 2.736 2.658 2.736Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ccELO_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.75 8.5h28.5v9H4.75z"
  })))));
};
export default SvgCcElo;